
export const ButtonIcon = (props)=>{
    const {Icon} = props;
    return(<div>
        <div className="border border-gray-500 rounded-full bg-white p-1 shadow-lg font-bold">{Icon}</div>
    </div> );
};

const Button = ()=>{
    return(<>

    </>);
};

export default Button;